/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { Form } from 'reactstrap';
import { FieldArray } from 'redux-form';
import { COMPONENT_POPULATION } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import renderEditComponent from './renderEditComponent/index.jsx';

type Props = {|
  form: string,
  currentComponent: {},
|};

const EditComponentItem = ({ form, currentComponent }: Props): Element<'div'> => (
  <div>
    <Form noValidate>
      <FieldArray
        form={form}
        currentComponent={currentComponent}
        name={COMPONENT_POPULATION}
        component={renderEditComponent}
      />
    </Form>
  </div>
);
export default EditComponentItem;
